var _linearGradient, _linearGradient2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPillShapeMobile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 500 66",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 250,
    x2: 233.75,
    y1: 0.000007,
    y2: 57.75
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 507.752,
    x2: 493.464,
    y1: -14.3208,
    y2: 47.0366
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546446,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.99991
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.999956.999956h466.000044c17.673 0 32 14.326944 32 32.000044s-14.327 32-32 32h-466.000044z",
    stroke: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.999956.999956h466.000044c17.673 0 32 14.326944 32 32.000044s-14.327 32-32 32h-466.000044z",
    stroke: "url(#b)",
    strokeOpacity: 0.4
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPillShapeMobile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pill-shape-mobile.0489ecd4fcde3172ad52b6f870f4c8fc.svg";